export const basicValueDataTypes = ['string', 'float64', 'decimal', 'int32', 'bool', 'datetime', 'int64'] as const;
